var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.iconClass,attrs:{"role":"presentation"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.icons[_vm.icon].id}})])}
var staticRenderFns = []

export { render, staticRenderFns }